module.exports = __webpack_public_path__ + "img/roll1.3384d76d.png";